// Libraries
import { MenuItemType } from 'antd/es/menu/hooks/useItems';

// Types
import { EquipmentUnitDataConeCrusher } from '../../../../../../types/crusher';
import { EdgeDeviceOperationalStatus } from '../../../../../../types/global';

export enum IFMType {
  asiNetwork = 'asiNetwork',
  asiNetworkTrend = 'asiNetworkTrend',
  ifm = 'ifm',
}

export type IFMItemTab = {
  key: IFMType;
  label: string;
};

export interface IFMProps {
  className?: string;
  onChangeView: (key: MenuItemType) => void;
  unitData: EquipmentUnitDataConeCrusher | null;
  edgeStatus: EdgeDeviceOperationalStatus | null;
  selectedView: IFMType;
  testId?: string;
}
